const React = require("react");

function ChevronRightIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9 5l7 7-7 7"
  }));
}

module.exports = ChevronRightIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/ChevronRightIcon.js
 ** module id = 477
 ** module chunks = 0
 **/